'use client';

import { useSyncExternalStore } from 'react';
import JobCard from '@/components/JobList/JobCard';
import Link from 'next/link';
import { useGreenhouse } from '@/contexts/GreenhouseProvider';

const emptySubscribe = () => () => {};

const CareerSavedJobsContent = () => {
  const { savedJobs } = useGreenhouse();

  const isMounted = useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false,
  );

  if (!isMounted) {
    return (
      <section className="sm:max-w-3xl mx-auto text-center py-20">
        <h1 className="text-heading-xl mb-4">Saved Jobs</h1>
        <p role="status" className="text-body-saans font-medium">
          Finding your saved jobs...
        </p>
      </section>
    );
  }

  if (savedJobs.length === 0) {
    return (
      <section className="text-center sm:max-w-3xl mx-auto py-20">
        <h1 className="text-heading-xl mb-4">No Saved Jobs</h1>
        <p className="text-body-saans font-medium my-4">You don&#8217;t currently have any saved jobs.</p>
        <p className="text-body-saans font-medium mb-4">
          But don&#8217;t worry &mdash; you can save any job you view and it will appear in a list here.
        </p>
        <p className="text-body-saans font-medium underline hover:no-underline">
          <Link href={`/careers/jobs/`}>Back to Job Search</Link>
        </p>
      </section>
    );
  }

  return (
    <section className="sm:max-w-3xl mx-auto">
      <h1 className="text-heading-xl text-center mb-12">Saved Jobs</h1>
      <div className="space-y-6">
        {savedJobs.map(job => (
          <JobCard key={job.id} job={job} />
        ))}
      </div>
    </section>
  );
};

export default CareerSavedJobsContent;
